import React, { useState } from "react";
import ReactModal from "react-modal";
import { useRecoilValue } from "recoil";
import { swapState } from "../../context/swapState";
import { useLiquidity } from "../../hooks/useLiquidity";
import SwapHeaderMenu from "./SwapHeaderMenu";
import SwapSetting from "./SwapSetting";

const SwapHeader = () => {
  const [activeMenu, setActiveMenu] = useState("Swap");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const swapData = useRecoilValue(swapState);

  const liquidity = useLiquidity();

  const transferTokens = async () => {
    const response = await liquidity.doAddLiquidity(
      "SSTI-SSTJ",
      "5",
      "3",
      "0.05"
    );
  };

  return (
    <div className="swap-header-container">
      <div className="swap-header-menu-component">
        {/* <SwapHeaderMenu
          activeMenu={activeMenu}
          onClick={transferTokens}
          name={"Swap"}
        /> */}
        {/* <SwapHeaderMenu
          activeMenu={activeMenu}
          onClick={() => setActiveMenu("Limit")}
          name={"Limit"}
        /> */}
        {/* <SwapHeaderMenu
          activeMenu={activeMenu}
          onClick={() => setActiveMenu("Gasless")}
          name={"Gasless"}
        /> */}
      </div>
      <div className="swap-header-menu-options">
        <div className="slippage-home">
          <span className="slippage-title">Slippage:</span>{" "}
          {(Number(swapData.slippage) * 100).toFixed(2) + " %"}
        </div>
        <span
          onClick={() => setIsModalOpen(true)}
          className="material-symbols-outlined options-settings"
        >
          settings
        </span>
      </div>
      <ReactModal
        isOpen={isModalOpen}
        className="custom-modal"
        onRequestClose={() => setIsModalOpen(false)}
      >
        <div className="modal-close-wrapper">
          <span
            onClick={() => setIsModalOpen(false)}
            className="material-symbols-outlined modal-close-button"
          >
            close
          </span>
        </div>
        {/* Settings are coming soon. */}
        <SwapSetting setIsModalOpen={setIsModalOpen}/>
      </ReactModal>
    </div>
  );
};

export default SwapHeader;
